const productData = [
  {
    id: 1,
    name: "corner.inc cropped tee",
    description: `
    Heavy weight 7 oz tee
    100% cotton
    Relaxed fit with a cropped length
    Made in USA

    Ships in ~10 days`,
    price: 44.00,
    images: [
      '/TeeFlatlay-Front.png',
      '/TeeFlatlay-Back.png',
      '/FemaleModelFront.png',
      '/FemaleModelBack.png',
      '/MaleModelFront.png',
      '/MaleModelBack.png',
    ],
    sizes: ["XS", "S", "M", "L"],
    // Shopify Variant IDs: Placeholder - please replace with actual IDs
    // Each size needs its own variant ID if they are distinct products in Shopify
    variants: [
      { id: "50316108824893", size: "XS", price: 44.00 },
      { id: "50316108857661", size: "S", price: 44.00 },
      { id: "50316108890429", size: "M", price: 44.00 },
      { id: "50316108923197", size: "L", price: 44.00 }
    ],
    category: "Tee" // Added for easier component differentiation
  },
  {
    id: 2,
    name: "corner.inc tote",
    description: `
    12 Liter 100% cotton tote
    Made in USA

    Ships in ~10 days`,
    price: 24.00,
    images: [
      '/ToteBagPic.png',
      '/toteFront.png',
      '/toteBack.png'
    ],
    // Shopify Variant ID: Placeholder - please replace with actual ID
    variantId: "50316118196541",
    category: "Tote" // Added for easier component differentiation
  }
];

export default productData; 